const init = async () => {
    toggleFilter();
    filtersAction();
    filterWrapToggle();

function toggleFilter() {
    const wrap = document.querySelector('.vertical-tab');
    const button = document.querySelector('.toggle-filter');
    if (!wrap || !button) return;

    button.addEventListener('click', () => {
        const isOpen = wrap.classList.toggle('open');

        if (!button.hasAttribute('data-originaltext')) {
            button.dataset.originaltext = button.textContent.trim();
        }

        button.textContent = isOpen 
            ? button.dataset.closetext 
            : button.dataset.originaltext;
    });
}


   function filtersAction() {
    const filterButtons = document.querySelectorAll('.filter-term-name');
    const clearButton = document.querySelector('.clear-all');
    const cards = document.querySelectorAll('.collection-card');
    const noResults = document.querySelector('.no-results');

    // Object to store selected filters grouped by taxonomy and logic
    const activeFilters = {};

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            const term = button.dataset.item;
            const taxonomy = button.dataset.taxonomy;
            const logic = button.dataset.logic || 'and';

            // Initialize if not exists
            if (!activeFilters[taxonomy]) {
                activeFilters[taxonomy] = { logic, terms: [] };
            }

            const terms = activeFilters[taxonomy].terms;

            // Toggle term
            const index = terms.indexOf(term);
            if (index > -1) {
                terms.splice(index, 1);
                button.classList.remove('active');
            } else {
                terms.push(term);
                button.classList.add('active');
            }

            // Remove taxonomy if empty
            if (terms.length === 0) delete activeFilters[taxonomy];

            updateCards();
            toggleClearButton();
        });
    });

    if (clearButton) {
        clearButton.addEventListener('click', () => {
            // Clear all filters
            for (let key in activeFilters) {
                delete activeFilters[key];
            }

            filterButtons.forEach(btn => btn.classList.remove('active'));
            updateCards();
            toggleClearButton();
        });
    }

    function updateCards() {
        let visibleCount = 0;

        cards.forEach(card => {
            const isVisible = shouldShowCard(card);
            if (isVisible) {
                showCard(card);
                visibleCount++;
            } else {
                hideCard(card);
            }
        });

        if (noResults) {
            noResults.style.display = visibleCount === 0 ? 'block' : 'none';
        }
    }

    function shouldShowCard(card) {
        for (const [taxonomy, filter] of Object.entries(activeFilters)) {
            const { logic, terms } = filter;

            if (logic === 'and') {
                for (const term of terms) {
                    if (!card.classList.contains(term)) return false;
                }
            }

            if (logic === 'or') {
                if (!terms.some(term => card.classList.contains(term))) return false;
            }
        }

        return true;
    }

    function showCard(card) {
        if (card.style.display === 'flex') return;

        card.style.opacity = 0;
        card.style.display = 'block'; // adjust to match your layout

        requestAnimationFrame(() => {
            card.style.opacity = 1;
        });
    }

    function hideCard(card) {
        card.style.opacity = 0;
        setTimeout(() => {
            card.style.display = 'none';
        }, 300);
    }

    function toggleClearButton() {
        if (!clearButton) return;

        const hasFilters = Object.keys(activeFilters).length > 0;

        if (hasFilters) {
            clearButton.classList.add('show');
            clearButton.style.display = 'inline-block';
        } else {
            clearButton.classList.remove('show');
            setTimeout(() => {
                if (Object.keys(activeFilters).length === 0) {
                    clearButton.style.display = 'none';
                }
            }, 300);
        }
    }

    // Init
    updateCards();
    toggleClearButton();
}

function filterWrapToggle() {
    document.querySelectorAll('.filter-wrap').forEach((wrap) => {
    const toggleBtn = wrap.querySelector('.filter-tax-name');
    const ul = wrap.querySelector('ul');

    toggleBtn.addEventListener('click', () => {
      wrap.classList.toggle('open');
    });
  });
}
    
};

export { init };